module.exports = __webpack_public_path__ + "img/logo_white.aab7a14c.svg";